import script from "./ConsumptionList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumptionList.vue?vue&type=script&setup=true&lang=js"

import "./ConsumptionList.vue?vue&type=style&index=0&id=32fac770&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32fac770"]])

export default __exports__